const daysArray = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu','Fri','Sat']
export default daysArray